import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DigitalWaiverService {

  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  getActiveDigitalWaiver(organizationId: string): any {
    return this.http.get(`${this.url}/digitalwaiver/organization/${organizationId}/active`);
  }

  getWaiversByOrganization(filter): any {
    return this.http.get(`${this.url}/digitalwaivers/organization`, { params: filter });
  }

  createWaiver(data: any): any {
    return this.http.post(`${this.url}/digitalwaiver/create`, data);
  }

  updateWaiver(id: string, data: any): any { 
    return this.http.put(`${this.url}/digitalwaiver/update/${id}`, data);  
  }

  deleteWaiver(data: any): any {
    return this.http.post(`${this.url}/digitalwaiver/delete`, data);
  }

  getWaiverEntries(filter): any {
    return this.http.get(`${this.url}/digitalwaiverentries/organization`, { params: filter });
  }

  manuallySendWaiver(data: any): any {
    return this.http.post(`${this.url}/digitalwaiverentry/send/manually`, data);
  }

  deleteWaiverEntry(data: any): any {
    return this.http.post(`${this.url}/digitalwaiverentry/delete`, data);
  }

  resendDigitalWaiverEntry(data: any): any {
    return this.http.post(`${this.url}/digitalwaiverentry/resend`, data);
  }
}
